import { useCallback, useMemo } from 'react';
import { useNovelRepository } from './useNovelRepository';
export type EntityListSort = 'updatedAt' | 'name';
export function useEntityListSort(key: string) {
  const { novel, updateNovelItem } = useNovelRepository();
  const sort = novel.entityListSortBy?.[key] || novel.entityListSortDefault || 'updatedAt';
  const setSort = useCallback((value: EntityListSort) => {
    void updateNovelItem({ entityListSortDefault: value, entityListSortBy: { ...(novel.entityListSortBy || {}), [key]: value } });
  }, [key, novel.entityListSortBy, updateNovelItem]);
  return { sort, setSort, sortItems: useCallback(<T extends { name?: string; updatedAt?: string }>(items: T[]) => [...items].sort((a,b) => sort === 'name' ? (a.name || '').localeCompare(b.name || '') : new Date(b.updatedAt || 0).getTime() - new Date(a.updatedAt || 0).getTime()), [sort]) };
}